import { extend } from 'underscore';

export const getSimplePreviewCarouselHeaderStyles = ({
  styleOverrides = {},
}) => () => ({
  title: extend({
    fontSize: 18,
    fontWeight: 'normal',
    lineHeight: '24px',
    margin: '20px 24px 16px 24px',
    '&.with-additional-tag': {
      marginRight: 8,
      display: 'inline-block',
    },
  }, styleOverrides.title),
});

export const getPreviewCarouselHeaderWithButtonsStyles = ({
  styleOverrides = {},
}) => () => ({
  headerRoot: extend({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }, styleOverrides.headerRoot),
  title: extend({
    fontSize: 18,
    fontWeight: 'normal',
    lineHeight: '24px',
    margin: '20px 24px 16px 24px',
    '&.with-additional-tag': {
      marginRight: 8,
      display: 'inline-block',
    },
  }, styleOverrides.title),
  buttons: extend({
    flexGrow: 1,
  }, styleOverrides.buttons),
});

export const getIncludeExcludeEditButtonStyles = ({
  styleOverrides = {},
}) => () => ({
  exclude: extend({}, styleOverrides.exclude),
  actionButtons: extend({
    display: 'inline-block',
    flexGrow: 0,
    marginRight: 16,
    textAlign: 'center',
  }, styleOverrides.actionButtons),
});

export const getReCropReplaceButtonsStyles = ({
  styleOverrides = {},
}) => () => ({
  recrop: extend({}, styleOverrides.recrop),
  replace: extend({}, styleOverrides.replace),
});
